import _ from 'lodash';
import { customerAlias } from './customerAlias';
import { currency } from './currency';
import store from '@/store';

export function qtDescription(qtDetail: any, showAsProformaInvoice: boolean = true): string {
  const qtValue = _.reduce(qtDetail.items, (sum, qtItem) => {
    return sum + (_.get(qtItem, 'productPrice.price', 0) * _.get(qtItem, 'totalQuantity', 0));
  }, 0);
  const vat = qtDetail.customer.exportCustomer ? 0 : _.get(store, 'state.staticData[company-detail].vatPercentage', 0);
  const multiplier = (100 + Number(vat)) / 100;
  const qtValuePlusVat = qtValue * multiplier;
  return `${showAsProformaInvoice ? 'PI': 'QT'}#: <b>${qtDetail._id}</b> / ${customerAlias(qtDetail.customer, false)} / Value: <b>${currency(qtValuePlusVat)}</b>`;
}